import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledApplicationForm = styled.div`
  .offer-validity-period {
    .row {
      display: flex;
      gap: 24px;
      align-items: flex-start;

      @media (max-width: ${breakpoints.lg}px) {
        flex-direction: column;
        gap: 0;
      }
    }

    .date {
      flex: 1;
      .ant-picker {
        width: 100%;
      }

      @media (max-width: ${breakpoints.lg}px) {
        width: 100%;
      }
    }
  }

  .address-finder {
    margin-bottom: 0;
  }

  .producer-comments {
    .textarea {
      .ant-input {
        min-height: 150px;
      }
    }
  }

  .warehouse-address {
    .anticon {
      margin-left: 6px;
      color: ${(props) => props.theme.manslauksZils};
      font-size: 14px;
    }
  }

  .quality-marks {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    .quality-mark-items {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 15px;
    }

    .quality-mark-item {
      display: flex;
      align-items: center;
      gap: 4px;
      white-space: nowrap;
      flex-shrink: 0;
    }

    .has-quality-mark {
      .ant-checkbox-checked .ant-checkbox-inner {
        background-color: ${(props) => props.theme.activeCheckboxBackground};
        border-color: ${(props) => props.theme.activeCheckboxBorder};

        &:after {
          border-color: ${(props) => props.theme.white};
        }
      }

      .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner {
        background-color: ${(props) => props.theme.activeCheckboxBackground};
        border-color: ${(props) => props.theme.activeCheckboxBorder};
        opacity: 1;
      }
    }

    .no-quality-mark {
      .ant-checkbox-checked .ant-checkbox-inner {
        background-color: ${(props) => props.theme.borderCheckbox};
        border-color: ${(props) => props.theme.disableCheckboxBorder};

        &:after {
          border-color: ${(props) => props.theme.disableCheckboxBorder};
        }
      }

      .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner {
        background-color: ${(props) => props.theme.borderCheckbox};
        border-color: ${(props) => props.theme.qualityMarkDisabled};
        opacity: 0.6;
      }
    }
  }

  .text-muted {
    color: ${(props) => props.theme.textColorSecondary};
    font-size: 14px;
    margin-top: 8px;
  }

  .text-info {
    color: ${(props) => props.theme.infoColor};
    font-size: 14px;
    margin-top: 8px;
  }

  .listing-date {
    margin-bottom: 20px;
  }

  .deadline-progress {
    display: flex;
    gap: 30px;
    align-items: center;
    text-wrap: nowrap;

    label {
      color: ${({ theme }) => theme.grayTextColor};
    }

    .deadline-date {
      font-weight: 600;
    }
  }

  .progress-bar {
    width: 100%;
    height: 3px;
    background-color: ${({ theme }) => theme.progressBar};
    border-radius: 3px;
    overflow: hidden;
    position: relative;
  }

  .progress-fill {
    height: 100%;
    background-color: ${({ theme }) => theme.progressBarFill};
    border-radius: 3px;
    transition: width 0.3s ease;
    position: relative;
    min-width: 2px;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .producer-comments,
    .listing-info {
      p {
        margin: 0;
      }

      .title {
        margin-bottom: 4px;
      }
    }

    .offer-validity-period {
      .row {
        flex-direction: column;
        gap: 30px;

        .date {
          width: 100%;
        }

        .ant-form-item {
          margin-bottom: 0;
        }
      }
    }
    .quality-marks {
      .quality-mark-items {
        display: grid;
        grid-template-columns: 1fr;
        gap: 15px;
      }
    }
  }
`;

export const StyledApplicationProductsForm = styled.div`
  .product-item {
    background: ${(props) => props.theme.white};
    border: 1px solid ${(props) => props.theme.colorBorder};
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 16px;

    .product-header {
      gap: 10px;
      display: flex;
      margin-bottom: 20px;

      .product-number {
        width: 24px;
        height: 24px;
        background-color: ${(props) => props.theme.colorPrimary};
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        color: ${(props) => props.theme.white};
      }

      .product-title {
        display: flex;
        gap: 4px;
      }

      .quality-marks {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        .quality-mark-item {
          display: flex;
          align-items: center;
          gap: 4px;
          white-space: nowrap;
          flex-shrink: 0;
        }

        .has-quality-mark {
          .ant-checkbox-checked .ant-checkbox-inner {
            background-color: ${(props) =>
              props.theme.activeCheckboxBackground};
            border-color: ${(props) => props.theme.activeCheckboxBorder};

            &:after {
              border-color: ${(props) => props.theme.white};
            }
          }

          .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner {
            background-color: ${(props) =>
              props.theme.activeCheckboxBackground};
            border-color: ${(props) => props.theme.activeCheckboxBorder};
            opacity: 1;
          }
        }

        .no-quality-mark {
          .ant-checkbox-checked .ant-checkbox-inner {
            background-color: ${(props) => props.theme.borderCheckbox};
            border-color: ${(props) => props.theme.disableCheckboxBorder};

            &:after {
              border-color: ${(props) => props.theme.disableCheckboxBorder};
            }
          }

          .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner {
            background-color: ${(props) => props.theme.borderCheckbox};
            border-color: ${(props) => props.theme.qualityMarkDisabled};
            opacity: 0.6;
          }
        }
      }

      .has-quality-mark {
        color: ${(props) => props.theme.qualityMarkSuccess};
      }

      .no-quality-mark {
        color: ${(props) => props.theme.qualityMarkDisabled};
      }
    }

    .product-form {
      .product-selection {
        flex: 1;
      }

      .ant-form-item {
        margin-bottom: 10px;
      }

      .quantity-and-unit {
        width: 100%;
        display: flex;

        .quantity-input {
          flex: 1;
          border-right: none;

          .ant-form-item {
            margin-bottom: 0;
          }

          .ant-input-number {
            width: 100%;
            border-right: 1px solid transparent;
          }

          .ant-input-number:hover {
            border-right: 1px solid ${(props) => props.theme.black};
          }

          .ant-input-number:focus-within {
            border-right: 1px solid ${(props) => props.theme.black};
          }
        }

        .ant-select {
          width: 75px;
          margin-top: 32px;

          .ant-form-item {
            margin-bottom: 0;
          }

          .ant-select-selector {
            background: ${(props) => props.theme.inputAddonBg};
          }

          .ant-select-dropdown {
            min-width: 200px;
          }
        }
      }

      .offer-type {
        display: flex;
        gap: 8px;

        .radio-options {
          display: flex;
          flex-direction: row;
          gap: 8px;
        }
      }
    }
  }

  .ant-divider {
    margin: 10px 0;
  }

  .product-warning-label {
    margin-bottom: 4px;
    color: ${({ theme }) => theme.errorBadge};
    font-size: 14px;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .product-item {
      padding: 12px;

      .product-header {
        flex-direction: column;

        .quality-marks {
          display: grid;
          grid-template-columns: 1fr;
        }
      }

      .product-form {
        .quantity-and-unit {
          .ant-select {
            height: 39px;
            margin-top: 30px;
          }
        }
      }
    }
  }
`;

export const StyledApplicationContractForm = styled.div`
  .contract-period {
    display: flex;
    gap: 30px;
    align-items: center;
    text-wrap: nowrap;
    padding: 10px 0;
    color: ${(props) => props.theme.grayTextColor};

    .contract-period-date {
      display: flex;
      gap: 10px;
      align-items: center;
    }

    .deadline-date {
      font-weight: 600;
      color: ${(props) => props.theme.textColor};
    }

    .progress-bar {
      width: 100%;
      height: 3px;
      background-color: ${({ theme }) => theme.progressBar};
      border-radius: 3px;
      overflow: hidden;
      position: relative;
    }

    .progress-fill {
      height: 100%;
      background-color: ${({ theme }) => theme.progressBarFill};
      border-radius: 3px;
      transition: width 0.3s ease;
      position: relative;
      min-width: 2px;
    }
  }

  .contract-template {
    .template-actions {
      display: flex;
      align-items: center;
      gap: 12px;

      .text-muted {
        color: ${(props) => props.theme.textColorSecondary};
        font-size: 14px;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .contract-period {
      flex-direction: column;
      gap: 10px;
      align-items: flex-start;
      padding: 0;
    }
  }
`;

export const StyledApplicationDeliveryForm = styled.div`
  .deliveries-list {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 24px;
  }

  .delivery-card {
    background: ${(props) => props.theme.white};
    border: 1px solid ${(props) => props.theme.colorBorder};
    border-radius: 8px;
    padding: 24px;

    .ant-form-item {
      margin-bottom: 0;
    }

    .delivery-header {
      margin-bottom: 20px;
      display: flex;
      gap: 10px;

      .delivery-number {
        width: 24px;
        height: 24px;
        background-color: ${(props) => props.theme.colorPrimary};
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        color: ${(props) => props.theme.white};
      }
    }

    .delivery-radio-section {
      .radio-options {
        flex-direction: row;
        gap: 20px;
      }
    }

    .delivery-price {
      .ant-form-item {
        margin-bottom: 0;
      }

      .ant-input-number {
        width: 100%;
      }
    }

    .frequency-and-unit {
      width: 100%;
      display: flex;

      .frequency-input {
        flex: 1;
        border-right: none;

        .ant-form-item {
          margin-bottom: 0;
        }

        .ant-input {
          width: 100%;
          border-right: 1px solid transparent;
        }

        .ant-input:hover {
          border-right: 1px solid ${(props) => props.theme.black};
        }

        .ant-input:focus-within {
          border-right: 1px solid ${(props) => props.theme.black};
        }
      }

      .ant-select {
        width: 180px;
        margin-top: 32px;

        .ant-form-item {
          margin-bottom: 0;
        }

        .ant-select-selector {
          background: ${(props) => props.theme.inputAddonBg};
        }

        .ant-select-dropdown {
          min-width: 200px;
        }
      }
    }

    .delivery-content {
      .row {
        display: flex;
        gap: 24px;
        align-items: flex-start;
        margin-bottom: 16px;
      }

      .delivery-frequency,
      .delivery-price,
      .delivery-start-date,
      .delivery-end-date,
      .delivery-address {
        flex: 1;
        .ant-picker {
          width: 100%;
        }
      }

      .products {
        gap: 5px;
        margin-bottom: 30px;

        label {
          margin: 0;
        }
      }

      .selected-products {
        display: flex;
        flex-direction: column;
        margin: 0 0 20px 0;
        background-color: ${(props) => props.theme.filterBackground};
        border-radius: 5px;
      }

      .product-quantity-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 12px;
        padding: 12px 0;
        border-radius: 4px;

        &:not(:last-child) {
          border-bottom: 1px solid ${(props) => props.theme.borderBottom};
        }

        .product-info {
          display: flex;
          flex-direction: column;
          gap: 4px;

          .product-name {
            font-weight: 600;
            color: ${(props) => props.theme.textColor};
          }

          .product-unit {
            font-size: 12px;
            color: ${(props) => props.theme.grey};
          }
        }

        .quantity-input {
          display: flex;
          align-items: center;
          gap: 8px;

          .delivery-quantity-input {
            width: 320px;
          }

          .ant-form-item {
            margin: 0;
          }

          .quantity-and-unit {
            display: flex;
            gap: 10px;

            .ant-input {
              width: 200px;
            }

            .ant-select {
              min-width: 120px;
              max-width: 200px;
              margin-top: 32px;
            }
          }
        }
      }
    }

    .delivery-actions {
      display: flex;
      justify-content: flex-end;
      margin-top: 16px;
    }
  }

  .additional-delivery-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid ${(props) => props.theme.colorBorder};
    border-radius: 5px;
    padding: 20px;
    background-color: ${(props) => props.theme.filterBackground};

    .action-button {
      padding: 4px 8px;
      height: auto;
      border: none;
      background: none;
      text-decoration: underline;
      cursor: pointer;

      &:hover {
        background: none;
        color: ${(props) => props.theme.black};
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .delivery-header {
      flex-direction: column;
    }

    .delivery-card {
      padding: 12px;

      .delivery-radio-section {
        .radio-options {
          display: flex;
          flex-direction: row;
          gap: 4px;

          .ant-radio-wrapper {
            span {
              text-wrap: nowrap;
            }
          }
        }
      }

      .delivery-content {
        .product-quantity-row {
          flex-direction: column;
          gap: 12px;
          align-items: flex-start;

          .quantity-input {
            flex-direction: column;
            align-items: flex-start;
            width: 100%;

            .ant-form-item {
              width: 100%;
            }
          }
        }
      }

      .frequency-and-unit {
        .ant-select {
          height: 43px;
          margin-top: 29px;
        }
      }
    }

    .additional-delivery-section {
      flex-direction: column;
      gap: 20px;
      align-items: flex-end;
    }
  }
`;

export const StyledApplicationSummary = styled.div`
  .summary-section {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .producer-comments p {
    margin-top: 8px;
    line-height: 1.6;
    color: ${(props) => props.theme.textColor};
  }

  .certificates-list,
  .products-list,
  .deliveries-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 16px;
  }

  .certificate-card {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 16px;
    border: 1px solid ${(props) => props.theme.colorBorder};
    border-radius: 8px;
    background: ${(props) => props.theme.white};

    .file-icon {
      font-size: 20px;
      color: ${(props) => props.theme.colorPrimary};
      flex-shrink: 0;
      margin-top: 2px;
    }

    .file-details {
      display: flex;
      flex-direction: column;
      gap: 4px;
      flex: 1;

      .file-name {
        font-weight: 500;
      }

      .file-meta {
        color: ${(props) => props.theme.grey};
        font-size: 14px;
      }
    }
  }

  .product-card {
    background: ${(props) => props.theme.white};
    border: 1px solid ${(props) => props.theme.colorBorder};
    border-radius: 8px;
    padding: 20px;

    .product-header {
      display: flex;
      gap: 10px;
      margin-bottom: 16px;

      .product-number {
        width: 24px;
        height: 24px;
        background-color: ${(props) => props.theme.colorPrimary};
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${(props) => props.theme.white};
        font-size: 14px;
        flex-shrink: 0;
      }

      .product-title {
        display: flex;
        gap: 10px;

        label {
          margin: 0;
        }
      }

      .quality-marks {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        .quality-mark-item {
          display: flex;
          align-items: center;
          gap: 4px;
          white-space: nowrap;
          flex-shrink: 0;

          &.has-quality-mark {
            .ant-checkbox-checked .ant-checkbox-inner {
              background-color: ${(props) =>
                props.theme.activeCheckboxBackground};
              border-color: ${(props) => props.theme.activeCheckboxBorder};

              &:after {
                border-color: ${(props) => props.theme.white};
              }
            }

            .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner {
              background-color: ${(props) =>
                props.theme.activeCheckboxBackground};
              border-color: ${(props) => props.theme.activeCheckboxBorder};
              opacity: 1;
            }
          }

          &.no-quality-mark {
            .ant-checkbox-checked .ant-checkbox-inner {
              background-color: ${(props) => props.theme.borderCheckbox};
              border-color: ${(props) => props.theme.disableCheckboxBorder};

              &:after {
                border-color: ${(props) => props.theme.disableCheckboxBorder};
              }
            }

            .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner {
              background-color: ${(props) => props.theme.borderCheckbox};
              border-color: ${(props) => props.theme.qualityMarkDisabled};
              opacity: 0.6;
            }
          }
        }
      }
    }

    .product-content {
      display: flex;
      flex-direction: column;
      font-size: 14px;
    }

    .selection-controls {
      .ant-form-item {
        margin-bottom: 0;
      }

      .ant-form-item-label {
        padding: 0;
      }

      .selection-radio-group {
        display: flex;
        flex-direction: column;
        margin: 10px 0;
      }

      .ant-input-number {
        width: 100%;
      }
    }
  }

  .delivery-card {
    background: ${(props) => props.theme.white};
    border: 1px solid ${(props) => props.theme.colorBorder};
    border-radius: 8px;
    padding: 20px;

    .delivery-header {
      display: flex;
      gap: 10px;
      margin-bottom: 16px;

      .delivery-number {
        width: 24px;
        height: 24px;
        background-color: ${(props) => props.theme.colorPrimary};
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${(props) => props.theme.white};
        font-size: 14px;
        flex-shrink: 0;
      }

      .delivery-info {
        flex: 1;

        label {
          margin: 0;
        }
      }
    }

    .delivery-content {
      display: flex;
      flex-direction: column;
      font-size: 14px;

      .delivery-products {
        display: flex;
        flex-direction: column;
      }
    }
  }

  .contract-period {
    display: flex;
    gap: 30px;
    align-items: center;
    text-wrap: nowrap;
    padding: 10px 0;
    color: ${(props) => props.theme.grayTextColor};

    .contract-period-date {
      display: flex;
      gap: 10px;
      align-items: center;
    }

    .deadline-date {
      font-weight: 600;
      color: ${(props) => props.theme.textColor};
    }

    @media (max-width: ${breakpoints.lg}px) {
      flex-direction: column;
      align-items: flex-start;
      text-wrap: wrap;
      gap: 8px;
    }
  }

  .terms {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }

    p {
      margin-top: 8px;
      line-height: 1.6;
      color: ${(props) => props.theme.textColor};
    }
  }

  .contract-template {
    margin-top: 16px;

    .template-actions {
      display: flex;
      align-items: center;
      gap: 12px;

      .text-muted {
        color: ${(props) => props.theme.textColorSecondary};
        font-size: 14px;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .product-title,
    .product-header {
      flex-direction: column;
    }

    .product-card {
      .product-header {
        .quality-marks {
          display: grid;
          grid-template-columns: 1fr;
        }
      }
    }
  }
`;
